const inputColumn = ({ name, placeholder }) => ({
	name,
	type: "input" as const,
	placeholder,
});

export default inputColumn;
